import React from 'react'

export const AuthContext = React.createContext({
  isAuthenticated: false,
  logoutHandler: () => {}
})


export const HouseContext = React.createContext({
  house: null,
  switchHouseHandler: () => {}
})


export const MqttClientContext = React.createContext({
  client: null
})



// WEBPACK FOOTER //
// ./src/contexts/index.js